// Typelizer digest f14393ce93419fd63727a7d0829feeb5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/invoice_templates */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoice_templates', {}, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/invoice_templates/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/invoice_templates/:id', params, options),
    method: 'delete',
  }),
}
